import * as API from '../api/StepForm';

export const sendForm = async (url, body) => {
  try {
    const response = await API.sendForm(url, body);
    return response.data;
  } catch (e) {
    return e;
  }
}